import React, { useEffect } from "react";
import { useVariables } from "../context/VariableContext";

const StatusDisplay = () => {
  const { variables } = useVariables();
useEffect(() => {
    console.log("📦 Обновлены переменные:", variables);
  }, [variables]);
  return (
    <div>
      <h4>list</h4>
      {Object.entries(variables).map(([key, value]) => (
        <h5 key={key}>{`${key}: ${value}`}</h5>
      ))}
    </div>
  );
};

export default StatusDisplay;
